import React, { Component } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View, SafeAreaView } from "react-native";
import fonts from "../constants/fonts";

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingVertical: 16
  },
  container: {
    paddingVertical: 24
  },
  text: {
    ...fonts.bold,
    fontSize: 16
  }
});

export default class Header extends Component {
  render() {
    const color = "#FFF";

    const iconStart = (
      <Image source={require("../assets/round_navigate_before_white.png")} />
    );

    const justifyContent = "flex-start";

    return (
      <SafeAreaView style={styles.container}>
        <TouchableOpacity onPress={this.props.onPress}>
          <View
            style={[
              styles.button,
              {
                justifyContent
              }
            ]}
          >
            {iconStart}

            <Text
              style={[
                styles.text,
                {
                  color
                }
              ]}
            >
              {this.props.text}
            </Text>
          </View>
        </TouchableOpacity>
      </SafeAreaView>
    );
  }
}
